import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/components/Main';
import Detail from '@/components/Detail';


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
    },
    {
      path: '/detail/:name',
      name: 'Detail',
      component: Detail,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js